
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/master-saas-and-services-agreement",
      function () {
        return require("private-next-pages/master-saas-and-services-agreement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/master-saas-and-services-agreement"])
      });
    }
  